import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { AppPageComponent } from '../../shared/ui';
import { TopLevelComponent, HeaderAction} from '../../shared/models';
import { StoreHelper, Store, UserService } from '../../shared/services';
import { InputFilterSheetComponent } from '../shared/ui';
import { Product, ProductTransferFilter } from '../shared/models';
import { ProductListService } from '../shared/services';


@Component({
    styles: [ require('./products-transfer.component.scss') ],
    template: require('./products-transfer.component.pug')
})
export class ProductsTransferComponent extends TopLevelComponent implements OnInit {
   @ViewChild(AppPageComponent) appPage;
   @ViewChild(InputFilterSheetComponent) inputFilterSheetComponent;

  products$: Observable<Product[]> = new Observable<Product[]>();
  productsToTransfer: Array<Product> = [];
  showTransferOverview: boolean = false;
  showProductsSelected: boolean = false;
  noProductSelectedError: boolean = false;
  locationOriginId: number;
  locationDestinationId: number;
  fg = new FormGroup({});
  notSelectedProducts$: Observable<Product[]>;
  loading = true;
  authorized = true;

  private  _locations: number[] = [];
  private _searchAction = { id: 'search', icon: 'search' };
  private _productFilter: ProductTransferFilter;
  private _notSelectedProducts = new Subject<Product[]>();

  constructor(
                public _location: Location,
                public _productListService: ProductListService,
                private _route: ActivatedRoute,
                public _store: Store,
                _storeHelper: StoreHelper,
                _userSvc: UserService
               ) {
          super(_store, _storeHelper, _userSvc);
          this.headerTitle = 'Transfer Item(s)';
          this.headerActions = [ this._searchAction ];
          this.subscribeToHeaderActions(this._reactToHeaderAction);

          this.notSelectedProducts$ = this._notSelectedProducts.asObservable();

   }

   ngOnInit() {
       this._route.params.forEach((params: Params) => {
            this.locationOriginId = +params['locationFrom'];
            this.locationDestinationId =  +params['locationTo'];
            this._locations.push(this.locationOriginId);
            this._productFilter = new ProductTransferFilter('', this._locations);
            this._getProducts('');
        });
   }

   onFilterChanged(name: string) {
        this.appPage.activatePreloader();
         this._getProducts(name);
     }

   coverClosed() {
        this.showTransferOverview = false;
        this.headerTitle = 'Transfer OverView';
    }

    showTransferCover(e: MouseEvent) {
        e.preventDefault();

        this.noProductSelectedError = false;

        if (this.productsToTransfer.length > 0) {
                this.showTransferOverview = true;
        } else {
            this.noProductSelectedError = true;
        }
    }

    coverProductsSelectedClosed() {
        this.showProductsSelected = false;
        this.headerTitle = 'Transfer OverView';
    }

    showProductsSelectedCover(e: MouseEvent) {
        e.preventDefault();
        this.showProductsSelected = true;
    }

   addProductToTransfer(product: Product) {
       let that = this;
       product.errorInTransfer = false;

       if ( product.quantity > 0) {
                product.isSelectedForTransfer = true;
                setTimeout(() => product.addedToTransfer = true, 900);
                that.productsToTransfer.push(product);
        } else {
                product.errorInTransfer = true;
        }
   }

   deleteProductFromSelected(product: Product) {
            let that = this;

             that.productsToTransfer.forEach(function(p, index){
                    if (p.id === product.id) {
                        that.productsToTransfer.splice(index, 1);
                    }
             });

            this._filterProducts();
   }

   goBack() {
       this._location.back();
   }

   private _getProducts(name: string) {
        this._productFilter.name = name;
        this.products$ =  this._productListService.getProducts(this._productFilter);
        this._filterProducts();
   }

   private _filterProducts() {
       let that = this;

       this.loading = true;
       this.products$.subscribe(res => {

                    let productsNotInTransfer: Product[] = [];

                    res.forEach(function(product) {
                        let isInTransfer = false;
                        that.productsToTransfer.forEach(function(productToTransfer) {
                                if (product.id === productToTransfer.id) {
                                    product.isSelectedForTransfer = true;
                                    product.addedToTransfer = true;
                                }
                        });

                        if (!isInTransfer) {
                             product.isSelectedForTransfer = false;
                             product.addedToTransfer = false;
                             productsNotInTransfer.push(product);
                        }
                    });

                    that._notSelectedProducts.next(productsNotInTransfer);
                    this.appPage.deactivatePreloader();
        },
        err => {
                this.authorized = this.userService.userHasAccess(err);
                this.appPage.deactivatePreloader();
                this.loading = false;
        },
        () => that.loading = false);
   }

   private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._searchAction.id && this.authorized) {
            this.inputFilterSheetComponent.toggle();
        }
   }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/products-transfer/products-transfer.component.ts